function customFilter() {
  var $filters = $("#filters");
  var $categoryFilterHover = $("#category-filter-hover");

  if (!$filters.length) {
    return;
  }

  /*
   * Důležité:
   * Hlavička a spodní tlačítko musí být přímo v #filters,
   * ne uvnitř #category-filter-hover, protože ten je scrollovaný obsah.
   */
  if (!$filters.find("> .filterCustomHeader").length) {
    $filters.prepend('<div class="filterCustomHeader">' + '<div class="h2">Filtrovat</div>' + '<button class="CloseFilters closeTop" type="button" aria-label="Zavřít filtr" title="Zavřít filtr"></button>' + "</div>");
  }

  if (!$filters.find("> .bottomFilterButton").length) {
    $filters.append('<div class="bottomFilterButton">' + '<button class="CloseFilters closeBottom btn-conversion btn" type="button" title="Filtrovat">Filtrovat</button>' + "</div>");
  }

  if (!$filters.find("> .filterPseudoScrollbar").length) {
    $filters.append('<div class="filterPseudoScrollbar" aria-hidden="true"><span></span></div>');
  }

  $(".filters-unveil-button-wrapper a").text("Filtrovat").attr("data-text", "Zavřít filtr");

  var $booleanTop = $(".filter-section-boolean .param-filter-top");

  if ($booleanTop.length && !$booleanTop.find("> h4").length) {
    $booleanTop.addClass("filter-section").prepend("<h4><span>Dostupnost</span></h4>");

    if ($categoryFilterHover.length && !$booleanTop.parent().is($categoryFilterHover)) {
      $categoryFilterHover.prepend($booleanTop);
    }
  }

  var $slider = $("#filters .slider-wrapper");

  if ($slider.length) {
    $slider.addClass("filter-section");

    if (!$slider.closest(".filter-sections").length && $categoryFilterHover.length) {
      $categoryFilterHover.prepend($slider);
    }
  }

  $(".filter-section").addClass("openIt");

  if (typeof openFilters !== "undefined" && $.isArray(openFilters) && openFilters.length) {
    var openFiltersSelector = openFilters.join(",");
    $(".filter-section").not(openFiltersSelector).removeClass("openIt");
  }

  $(".filter-section").each(function () {
    var $section = $(this);

    if ($section.find(".filter-label.active").length || $section.find("input:checked").length || $section.find(".active").length) {
      $section.addClass("openIt");
    }
  });

  $("html")
    .off("click.customFilterSectionToggle")
    .on("click.customFilterSectionToggle", "#filters .filter-section h4", function () {
      $(this).closest(".filter-section").toggleClass("openIt");
      updateFilterPseudoScrollbar();
    });

  initFilterPseudoScrollbar();
  updateFilterPseudoScrollbar();
}

function getFilterScrollElement() {
  return $("#filters .filter-sections").first();
}

function initFilterPseudoScrollbar() {
  var $scrollEl = getFilterScrollElement();

  if (!$scrollEl.length) {
    return;
  }

  $scrollEl.off("scroll.filterPseudoScrollbar").on("scroll.filterPseudoScrollbar", function () {
    updateFilterPseudoScrollbar();
  });

  $(window)
    .off("resize.filterPseudoScrollbar orientationchange.filterPseudoScrollbar")
    .on("resize.filterPseudoScrollbar orientationchange.filterPseudoScrollbar", function () {
      setTimeout(updateFilterPseudoScrollbar, 100);
    });
}

function updateFilterPseudoScrollbar() {
  var $filters = $("#filters");
  var $scrollEl = getFilterScrollElement();
  var $bar = $filters.find("> .filterPseudoScrollbar");
  var $thumb = $bar.find("span");

  if (!$filters.length || !$scrollEl.length || !$bar.length || !$thumb.length) {
    return;
  }

  var el = $scrollEl.get(0);
  var scrollHeight = el.scrollHeight;
  var clientHeight = el.clientHeight;
  var scrollTop = el.scrollTop;

  if (scrollHeight <= clientHeight + 2) {
    $bar.removeClass("isVisible");
    return;
  }

  var trackHeight = $bar.height();
  var thumbHeight = Math.max(36, Math.round((clientHeight / scrollHeight) * trackHeight));
  var maxTop = trackHeight - thumbHeight;
  var top = Math.round((scrollTop / (scrollHeight - clientHeight)) * maxTop);

  $bar.addClass("isVisible");
  $thumb.css({
    height: thumbHeight + "px",
    transform: "translateY(" + top + "px)",
  });
}

function showActiveFilters() {
  const $activeLabels = $(".filter-label.active");
  const hasActive = $activeLabels.length > 0;
  let $wrapper = $(".chooseFilters");
  if (!hasActive) {
    $wrapper.remove();
  } else {
    if (!$wrapper.length) {
      $wrapper = $('<div class="chooseFilters"></div>').insertBefore("#category-header");
    }
    $wrapper.empty();

    $wrapper.prepend("<div>Aktivní filtry:</div>");
    $activeLabels.each(function () {
      $wrapper.append($(this).clone().removeClass("active"));
    });

    const $clear = $("#clear-filters");
    if ($clear.length) {
      const $clearClone = $clear.clone(true, true);

      $clearClone.addClass("clear-all-filters").find("a").text("Zrušit všechny filtry");

      $wrapper.append($clearClone);
    }
  }

  $(document).on("click", ".chooseFilters label.filter-label", function () {
    const scrollTop = $(window).scrollTop();

    requestAnimationFrame(function () {
      $(window).scrollTop(scrollTop);
    });

    setTimeout(function () {
      $(window).scrollTop(scrollTop);
    }, 50);
  });
}

function customCategory() {
  $("a.pagination__link--prev").closest("li").addClass("prev");
  $("a.pagination__link--next").closest("li").addClass("next");
  $("body:not(.type-detail) .loadMore__button").text("Načíst dalších " + $(".loadMore__button").text().replace(/\D/g, "") + " produktů");
  if ($(".lastWiewProducts").length) {
    $(".lastWiewProducts").closest(".benefitBanner__item").addClass("lastProducts fullWidth");
  }
  /*
    if ($(".category-perex .help").length) {
      $(".category-top").append($(".category-perex .help").clone());
    }
  
    if ($(".category-perex>p").length > 1) {
      if($('.category__secondDescription').text().length>1){
         $(".category-perex:not(.empty-content)").append(
        '<span class="moreInfo">Více informací</span>',
      );
      }
     $(".category-perex .moreInfo").on("click", function () {
    $(".category-perex").toggleClass("opened");
  
    $("html, body").animate({
      scrollTop: $(".category__secondDescription").last().offset().top - 50
    }, 500);
  });
  
    $(".category-perex .moreInfo").on("click", function () {
        $(".category-perex").toggleClass("opened");
      });
    }*/
  $("#listSortingHeading").html("");
  $("#listSortingHeading").prepend(`<span class="pc">Řazení produktů:</span>`);
  $("#listSortingHeading").prepend('<span class="mobile">Řazení:</span>');

  $("#category-header .listSorting h2").append($(".listSorting__controls .listSorting__control--current").clone());

  $("#category-header #listSortingHeading").click(function () {
    $("#category-header .listSorting").toggleClass("openIt");
  });
  if ($(".listItemsTotal").length) {
    var count = $(".listItemsTotal strong").text();
    $(".listItemsTotal").html("<strong>" + count + "</strong> produktů");
  }

  if ($(".subcategories").length && !$(".type-category .subCatTitle + .subcategories").length) {
    $(".type-category .content-wrapper-in").after($(".category-top .subcategories").clone());
    $(".type-category .content-wrapper-in").after("<h2 class='subCatTitle'>Vyber si z podkategorií</h2>");
  }
  if (!$("h2 + .benefitBanner.position--benefitCategory").length) {
    $(".benefitBanner.position--benefitCategory").before('<h2 class="uspHead">Ve Švihej ti vždy kryjeme záda</h2>');
  }
  if ($(".category__secondDescription").length && !$(".benefitBanner .category__secondDescription").length) {
    $(".benefitBanner").append($(".category__secondDescription").clone());
  }
  if ($(".type-category .desc-blog").length) {
    $(".desc-blog").closest(".benefitBanner__item").addClass("blogBanner fullWidth");
  }

  if (!$(".sidebar.sidebar-left .contact-wrap").length) {
    $(".sidebar.sidebar-left").append($("#footer .contact-wrap").clone());
  }
  if (!$(".category-content-wrapper .contact-wrap").length) {
    $(".category-content-wrapper").append($("#footer .contact-wrap").clone());
  }

  $(".category-content-wrapper .banner-category").each(function (i) {
    if (!$(".sidebar.sidebar-left .banner-category").eq(i).length) {
      $(".sidebar.sidebar-left").append($(this).clone());
    }
  });
}

function initFilterHint() {
  customFilter();
  showActiveFilters();
  customCategory();
  renderProductsListCount();
  renderRecentlyViewed();
}

$(document).ready(initFilterHint);
document.addEventListener("ShoptetDOMPageContentLoaded", initFilterHint);
document.addEventListener("ShoptetPageSortingChanged", initFilterHint);
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", initFilterHint);

document.addEventListener("ShoptetDOMContentLoaded", renderProductsListCount);

function sklonujProdukt(totalProducts) {
  totalProducts = parseInt(totalProducts, 10) || 0;

  if (totalProducts === 1) {
    return `produkt`;
  } else if (totalProducts >= 2 && totalProducts <= 4) {
    return `produkty`;
  } else {
    return `produktů`;
  }
}

function renderProductsListCount() {
  var statusText = $("#paginationStatus").text().trim();

  var page = 1;
  var lastPage = 1;

  var paginationMatch = statusText.match(/straně\s+(\d+)\s+z\s+(\d+)/);

  if (paginationMatch) {
    page = parseInt(paginationMatch[1], 10);
    lastPage = parseInt(paginationMatch[2], 10);
  }

  var totalProducts = parseInt($(".itemsTotal strong").first().text().trim() || "0", 10);

  var productsOnPage = 24;
  var seenProducts;

  if (page >= lastPage) {
    seenProducts = totalProducts;
  } else {
    seenProducts = productsOnPage * page;
  }

  seenProducts = Math.min(seenProducts, totalProducts);

  var percent = totalProducts > 0 ? ((seenProducts / totalProducts) * 100).toFixed(1) : 0;

  $(".itemTotalCount").remove();

  $(".goToTop").append('<div class="itemTotalCount">' + "<p>Již jste viděli <b>" + seenProducts + " z " + totalProducts + "</b> produktů</p>" + '<span class="line"><span style="width:' + percent + '%;"></span></span>' + "</div>");
}

$("html")
  .off("click.closeCustomFilters")
  .on("click.closeCustomFilters", "#filters .CloseFilters", function (e) {
    e.preventDefault();

    const $button = $('.filters-unveil-button-wrapper a[data-unveil="filters"]');

    if ($button.length) {
      $button.trigger("click");

      setTimeout(function () {
        $button.attr("data-text", "Zavřít filtr").text("Filtrovat");
      }, 50);
    } else {
      $("#filters").removeClass("visible");
      $("body").removeClass("filters-visible");
    }
  });

function renderSubcategories() {
  $(".subcategories li img").each(function () {
    const $img = $(this);

    const src = $img.attr("src");
    const dataSrc = $img.attr("data-src");

    if (src) {
      $img.attr("src", src.replace("/thumb/", "/orig/"));
    }

    if (dataSrc) {
      $img.attr("data-src", dataSrc.replace("/thumb/", "/orig/"));
    }
  });
}

$(document).ready(function () {
  renderSubcategories();
  fixFilter();
});

document.addEventListener("ShoptetDOMPageContentLoaded", function () {
  renderSubcategories();
  fixFilter();
});
document.addEventListener("ShoptetPageSortingChanged", function () {
  renderSubcategories();
  fixFilter();
});
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function () {
  renderSubcategories();
  fixFilter();
});
document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
  renderSubcategories();
  fixFilter();
});

function fixFilter() {
  if ($("body.mobile:not(.filters-visible)").length) {
    $("#filters").removeClass("visible");
  }
}
